import { Messages } from '../../../../codegen/Localize';
import { editPublishedConnection } from '../../../../publishedConnection/actions/EditPublishedConnectionReduxAction';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IWebEditPublishedConnectionAction } from '../../../../ts/ServerApi/types/actionNames';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const EditPublishedConnectionEntityAction: IEntityAction<IContentInfo<'publishedConnection'>, IWebEditPublishedConnectionAction> = {
  name: EntityActionNames.EditPublishedConnection,
  translateName: Messages.editPublishedConnection,
  isVisible: () => FeatureFlags.publishedConnectionEditorEnabled,
  isClickable: (availableActions: IWebEditPublishedConnectionAction) => !!availableActions && availableActions.webEditPublishedConnection,
  createReduxAction: (targetItems: IContentInfo[]) => editPublishedConnection(targetItems[0])
};
